export enum InventoryTypeOptions {
  REUSE = "Reuse",
  RECYCLING = "Recycling",
}
